import React, { useEffect, useState } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button';
import Swal from 'sweetalert2';
import './PermisosSumaEquipos.scss';
import {
    getAppModules,
    getUserAppPermissions,
    getUsersList,
    setUserAppPermissions,
} from './Integracion';

const PermisosSumaEquipos = () => {
    const [people, setPeople] = useState([]);
    const [modules, setModules] = useState([]);
    const [selectedPerson, setSelectedPerson] = useState(null);
    const [checkedModules, setCheckedModules] = useState([]);
    const [cargando, setCargando] = useState(false);
    const [guardando, setGuardando] = useState(false);

    useEffect(() => {
        const getData = async () => {
            const [usuarios, modulos] = await Promise.all([getUsersList(), getAppModules()]);
            setPeople(usuarios || []);
            setModules((modulos || []).filter((m) => m.ACTIVO));
        };
        getData();
    }, []);

    useEffect(() => {
        if (!selectedPerson) return;

        if (selectedPerson.id == null) {
            Swal.fire({
                title: 'Colaborador sin usuario',
                text: 'añade un id_usuario a la tabla de colaborador',
                icon: 'error',
            });
            return;
        }

        let cancelado = false;
        const getData = async () => {
            setCargando(true);
            const permisos = await getUserAppPermissions(selectedPerson.id);
            if (cancelado) return;
            setCheckedModules((permisos || []).map((p) => p.ID_MODULO));
            setCargando(false);
        };
        getData();

        return () => {
            cancelado = true;
        };
    }, [selectedPerson]);

    const onPersonChange = (e) => {
        setSelectedPerson(e.value);
        setCheckedModules([]);
    };

    const onModuleChange = (moduleId) => {
        setCheckedModules((prev) => (prev.includes(moduleId)
            ? prev.filter((id) => id !== moduleId)
            : [...prev, moduleId]));
    };

    const todosMarcados = modules.length > 0 && modules.every((m) => checkedModules.includes(m.ID));

    const toggleTodos = () => {
        setCheckedModules(todosMarcados ? [] : modules.map((m) => m.ID));
    };

    const savePermissions = async () => {
        if (!selectedPerson) {
            Swal.fire({ title: 'Selecciona una persona primero', icon: 'warning' });
            return;
        }
        if (selectedPerson.id == null) {
            Swal.fire({
                title: 'Colaborador sin usuario',
                text: 'añade un id_usuario a la tabla de colaborador',
                icon: 'error',
            });
            return;
        }

        try {
            setGuardando(true);
            const result = await setUserAppPermissions(selectedPerson.id, checkedModules);
            if (result?.success === false) {
                Swal.fire({ title: 'Error al actualizar datos', text: result.message, icon: 'error' });
                return;
            }
            Swal.fire({ title: 'Actualizado con éxito', icon: 'success' });
        } catch (error) {
            console.error('[PermisosSumaEquipos] Error en savePermissions:', error);
            Swal.fire({ title: 'Error al actualizar datos', icon: 'error' });
        } finally {
            setGuardando(false);
        }
    };

    return (
        <div>
            <div className="service-panel__header shadow-2">
                <div className="flex flex-wrap justify-content-end align-items-center gap-3 md:p-3 mx-auto">
                    <Button
                        label="Guardar Permisos"
                        icon="pi pi-save"
                        onClick={savePermissions}
                        className="save-button"
                        loading={guardando}
                        disabled={cargando}
                    />
                </div>
            </div>

            <div className="app-permissions-container">
                <div className="selection-section">
                    <label htmlFor="app-person-dropdown" className="label-style">Selecciona una persona:</label>
                    <Dropdown
                        id="app-person-dropdown"
                        value={selectedPerson}
                        options={people}
                        onChange={onPersonChange}
                        optionLabel="name"
                        placeholder="Seleccionar Persona"
                        className="person-dropdown"
                        filter
                        filterBy="name"
                        emptyFilterMessage="Sin resultados"
                    />
                </div>

                {selectedPerson?.id != null && (
                    <div className="modules-list-section">
                        <div className="modules-list-header">
                            <p className="modules-list-title">
                                Módulos de Suma Equipos para: <span className="person-name">{selectedPerson.name}</span>
                            </p>
                            <Button
                                label={todosMarcados ? 'Desmarcar todos' : 'Marcar todos'}
                                icon={todosMarcados ? 'pi pi-times' : 'pi pi-check-square'}
                                className="p-button-text p-button-sm"
                                onClick={toggleTodos}
                                disabled={cargando || modules.length === 0}
                            />
                        </div>

                        {cargando ? (
                            <p className="modules-empty">Cargando permisos...</p>
                        ) : modules.length === 0 ? (
                            <p className="modules-empty">No hay módulos disponibles.</p>
                        ) : (
                            <div className="modules-container">
                                {modules.map((module) => {
                                    const marcado = checkedModules.includes(module.ID);

                                    return (
                                        <div
                                            key={module.ID}
                                            className={`module-item ${marcado ? 'module-item--checked' : ''}`}
                                            onClick={() => onModuleChange(module.ID)}
                                        >
                                            <Checkbox
                                                inputId={`app-module-${module.ID}`}
                                                checked={marcado}
                                                onChange={() => onModuleChange(module.ID)}
                                                onClick={(e) => e.stopPropagation()}
                                                className="permission-checkbox"
                                            />
                                            <label
                                                htmlFor={`app-module-${module.ID}`}
                                                className="permission-label"
                                                onClick={(e) => e.stopPropagation()}
                                            >
                                                {module.NOMBRE.charAt(0).toUpperCase() + module.NOMBRE.slice(1)}
                                            </label>
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default PermisosSumaEquipos;
